import { render, staticRenderFns } from "./DfCorrectionHistoryModal.vue?vue&type=template&id=45e782a5&scoped=true"
import script from "./DfCorrectionHistoryModal.vue?vue&type=script&lang=js"
export * from "./DfCorrectionHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./DfCorrectionHistoryModal.vue?vue&type=style&index=0&id=45e782a5&prod&scoped=true&lang=css"
import style1 from "./DfCorrectionHistoryModal.vue?vue&type=style&index=1&id=45e782a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e782a5",
  null
  
)

export default component.exports